import "@fontsource-variable/inter";
import "@/styles/index.css";
import "./styles/_main.scss";
import "react-toastify/dist/ReactToastify.css";

import { I18nConfig } from "@/core/i18n";
import i18next from "i18next";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";

import "@/core/zod";

import { Portal } from "@headlessui/react";
import { ToastContainer } from "react-toastify";

import App from "./App";

i18next.init(I18nConfig);

// Global handler for Vite chunk load errors (e.g. after a new deployment)
window.addEventListener("vite:preloadError", (event) => {
  console.warn("Vite preload error detected. A new version may be available.", event);
  const reloadKey = "chunk-failed-reload";
  const hasReloaded = sessionStorage.getItem(reloadKey);

  if (!hasReloaded) {
    sessionStorage.setItem(reloadKey, "true");
    console.info("Reloading page to fetch latest version...");
    window.location.reload();
  } else {
    console.error("Page already reloaded once, but chunk still failed to load.");
    sessionStorage.removeItem(reloadKey);
  }
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <I18nextProvider i18n={i18next}>
    <App />
    <Portal>
      <ToastContainer theme="colored" />
    </Portal>
  </I18nextProvider>
);
